module.exports = __webpack_public_path__ + "static/media/como-36.d838f1db.jpg";